/**
 * HelpfulTips Component
 * Displays helpful search tips for court case searches
 */

import React from 'react';

import {
  TipsContainer,
  TipsGrid,
  TipCard,
  TipIconContainer,
  TipContent,
  TipTitle,
  TipDescription,
  SectionTitle,
} from './components';

// ============= TYPES =============
export interface HelpfulTip {
  id: string;
  title?: string;
  text: string;
  icon?: string;
}

export interface HelpfulTipsProps {
  tips: HelpfulTip[];
  sectionTitle?: string;
  testId?: string;
}

// ============= COMPONENT =============
export const HelpfulTips: React.FC<HelpfulTipsProps> = ({
  tips,
  sectionTitle = 'Helpful tips:',
  testId = 'helpful-tips',
}) => {
  if (!tips || tips.length === 0) {
    return null;
  }

  return (
    <TipsContainer data-testid={testId}>
      <SectionTitle>{sectionTitle}</SectionTitle>
      <TipsGrid>
        {tips.map((tip, index) => (
          <TipCard key={tip.id}>
            {tip.icon && (
              <TipIconContainer>
                <img src={tip.icon} alt={tip.title || `Tip ${index + 1}`} />
              </TipIconContainer>
            )}
            <TipContent>
              <TipTitle>{tip.title || `Tip #${index + 1}`}</TipTitle>
              <TipDescription>{tip.text}</TipDescription>
            </TipContent>
          </TipCard>
        ))}
      </TipsGrid>
    </TipsContainer>
  );
};

export default HelpfulTips;
